var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51953 11H5.4987C5.98493 11 6.45124 11.1932 6.79506 11.537C7.13888 11.8808 7.33203 12.3471 7.33203 12.8333C7.33203 13.3196 7.52519 13.7859 7.869 14.1297C8.21282 14.4735 8.67913 14.6667 9.16536 14.6667H12.832C13.3183 14.6667 13.7846 14.4735 14.1284 14.1297C14.4722 13.7859 14.6654 13.3196 14.6654 12.8333C14.6654 12.3471 14.8585 11.8808 15.2023 11.537C15.5462 11.1932 16.0125 11 16.4987 11H19.4779",
    stroke: "white",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4779 9.51009V13.9788C19.4779 15.4375 18.8984 16.8365 17.867 17.8679C16.8355 18.8994 15.4366 19.4788 13.9779 19.4788H8.01953C6.56084 19.4788 5.16189 18.8994 4.13044 17.8679C3.09899 16.8365 2.51953 15.4375 2.51953 13.9788V8.02051C2.51953 6.56182 3.09899 5.16287 4.13044 4.13142C5.16189 3.09997 6.56084 2.52051 8.01953 2.52051H12.4883",
    stroke: "white",
    strokeWidth: 0.916667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 1.04199C17.4761 0.98202 18.3291 1.18548 18.9121 1.63184C19.489 2.07359 19.8143 2.7623 19.6895 3.70996V3.71484C19.6327 4.33748 19.2233 4.73907 18.8115 5.08984L18.8096 5.0918C18.6021 5.27695 18.3754 5.41897 18.1416 5.58398C17.9116 5.74633 17.682 5.92689 17.4951 6.17871H17.4941C17.3725 6.34376 17.3074 6.54672 17.2695 6.76172C17.2376 6.94327 17.2257 7.14046 17.2178 7.33984H15.875C15.9078 6.662 15.9759 6.13726 16.2578 5.7334C16.4147 5.51957 16.6464 5.33428 16.8994 5.14258C17.1473 4.95482 17.4167 4.75929 17.624 4.53613L17.625 4.53711C17.7351 4.41915 17.9075 4.21436 18.0273 3.97461C18.1461 3.73699 18.2235 3.44308 18.1055 3.16113L18.1045 3.16016L18.0586 3.06836C17.9373 2.86559 17.7286 2.73224 17.4883 2.65332C17.2133 2.56309 16.8836 2.53969 16.5518 2.57129H16.5488C16.2015 2.61267 15.9217 2.76374 15.7275 2.99414C15.5561 3.19781 15.4567 3.45812 15.4307 3.74805H13.873C13.9268 2.91502 14.168 2.27685 14.5879 1.83105C14.9721 1.42321 15.5147 1.16456 16.2246 1.07129L16.5391 1.04199Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.229167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5791 8.24121C17.0662 8.24121 17.459 8.63013 17.459 9.10547C17.4589 9.58071 17.0662 9.96875 16.5791 9.96875C16.0922 9.96853 15.7003 9.58058 15.7002 9.10547C15.7002 8.63026 16.0922 8.24143 16.5791 8.24121Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.229167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/FaqIcon.5d42674020c2e7da4333cce098ea786e.svg";
export { ForwardRef as ReactComponent };